import { ReactNode } from 'react'

import { MapHome } from '@new/domains/properties/screens/viewMode/ViewMode.types'

export interface HomeLocationProps {
  id?: string
  latitude?: number
  longitude?: number
  name: string
  region?: {
    name?: string
  }
  markerType?: MapMarkerType
}

export type BoundBox =
  | [number, number, number, number]
  | [number, number, number, number, number, number]

export enum MapMarkerType {
  vacation = 'VACATION',
  hotel = 'HOTEL',
  offBoarded = 'OFF_BOARDED',
}

export interface MapHomeExtended<MetadataType = any> extends MapHome {
  metadata?: MetadataType
  markerType: MapMarkerType
  count?: number
  skipClustering?: boolean
  customHomeIcon?: ReactNode
  customMarketColor?: string
}
